/**
 * Copyright (C) 2018 Egylis,
 * Siège social, 46 rue René Clair, 75892 PARIS cedex 18 - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 16/11/18.
 *
 * Version : Generator 2.0.9
 */

/**
 * Log Levelt Type Status Enum
 */
export enum LogLevelType {
    /**
     * 1
     */
    L1 = <any>'1',
    /**
     * 2
     */
    L2 = <any>'2',
    /**
     * 3
     */
    L3 = <any>'3'
}
